import { render } from "./Form.vue?vue&type=template&id=152c825e&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=152c825e&lang=css"
import "./Form.vue?vue&type=style&index=1&id=152c825e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152c825e"]])

export default __exports__